<template>
  <div class="uc-password-forget">
    <div class="uc-password-forget__box">
      <div v-if="!isSendMail" class="uc-password-forget__content">
        <h3 class="uc-password-forget__title">
          重置密码
        </h3>
        <ds-form ref="formData" class="uc-password-forget__form" :model="formData" label-width="80px">
          <ds-form-item
            :rules="[
              { required: true, message: '请输入邮箱地址', trigger: 'blur' },
              { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
            ]"
            label="邮箱："
            prop="mail"
          >
            <ds-input
              v-model="formData.mail"
              placeholder="请输入邮箱地址"
              style="width: 100%;"
              @keyup.enter="submitForm"
              @input="isNoReg = false"
            />
            <div v-if="isNoReg" class="ds-form-item__error">
              该邮箱尚未注册数说故事用户中心
            </div>
          </ds-form-item>
          <ds-form-item
            :rules="[
              { required: true, message: '请输入验证码', trigger: 'blur' }
            ]"
            label="验证码："
            prop="verify"
          >
            <ds-input
              v-model="formData.verify"
              placeholder="请输入下方验证码"
              style="width: 100%;"
              @keyup.enter="submitForm"
              @input="isNoReg = false"
            />
          </ds-form-item>
          <ds-form-item>
            <div class="uc-password-forget__verify">
              <img :src="verifyCodeData.imgString" alt="">
              <i class="el-icon-refresh uc-password-forget__refresh" @click="getVerifyCode" />
            </div>
          </ds-form-item>
          <ds-form-item class="uc-password-forget__pt10">
            <ds-button
              class="uc-password-forget__button"
              :loading="loading"
              size="large"
              type="primary"
              @click="submitForm"
            >
              下一步
            </ds-button>
          </ds-form-item>
        </ds-form>
        <p class="uc-password-forget__text">
          重置密码链接将会发送至你的注册邮箱
        </p>
      </div>

      <div v-if="isSendMail" class="uc-password-forget__content">
        <div class="uc-password-forget__form">
          <div class="uc-password-forget__text uc-password-forget__suceess-text">
            已经将重置密码的链接发送至{{ formData.mail }},有效期24小时，请尽快重置密码！
          </div>
          <div class="uc-password-forget__text">
            <ds-button class="uc-password-forget__button" type="primary" size="large" @click="goLogin">
              返回登录
            </ds-button>
          </div>
        </div>
      </div>
    </div>
    <div class="uc-password-forget__app-footer">
      Copyright © 2018广州数说故事信息科技有限公司 All Rights Reserved
    </div>
  </div>
</template>

<script>
const PORT = {
  resetPasswordMail: '/user/resetPassword',
  checkMail: '/user/email/check',
  verifyCode: '/api/v1/captchas/getPic'
}

export default {
  name: 'ResetPassword',
  data() {
    return {
      formData: {
        mail: '',
        verify: ''
      },
      verifyCodeData: {},
      isSendMail: false,
      isNoReg: false,
      loading: false
    }
  },
  mounted() {
    this.formData.mail = this.$route.query.email || ''
    this.getVerifyCode()
  },
  methods: {
    getVerifyCode() {
      this.$ucProxy({
        url: PORT.verifyCode,
        type: 'post'
      }).then(res => {
        this.verifyCodeData = res
      })
    },
    submitForm() {
      this.$refs.formData.validate((valid) => {
        if (valid) {
          this.checkMailPort()
        } else {
          return false
        }
      })
    },
    // 验证是否注册用户中心
    checkMailPort() {
      this.loading = true
      this.$ucProxy({
        url: PORT.checkMail,
        type: 'get',
        data: {
          userEmail: this.formData.mail
        }
      }, {
        showMeg: false
      }).then(res => {
        if (!res.success) {
          this.isNoReg = true
          this.loading = false
        } else {
          this.resetPasswordMailPort()
        }
      })
    },
    resetPasswordMailPort() {
      // 这个 from 必须要传的，邮件的重置密码地址依然是 uc.datastory.com.cn 因此不能撤掉原来的
      const data = {
        userEmail: this.formData.mail,
        requestId: this.verifyCodeData.requestId,
        code: this.formData.verify,
        from: this.$route.query.redirect_url
      }
      this.$ucProxy({
        url: PORT.resetPasswordMail,
        type: 'post',
        data: data
      }).then(res => {
        this.loading = false
        if (!res.success) return
        this.isSendMail = true
      }).catch(() => {
        this.loading = false
      })
    },
    goLogin() {
      if (this.$route.query.redirect_url) {
        window.location.replace(this.$route.query.redirect_url)
      } else {
        this.$router.push({ name: 'Login' })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.uc-password-forget {
  position: relative;
  height: 100%;
  overflow: auto;
  background: #EEEEEE;
  color: #666666;

  &__box {
    margin: 0 128px;
    background: #FFFFFF;
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 560px;
  }

  &__content {
    width: 420px;
    padding: 80px 0;
    text-align: center;
  }

  &__title {
    padding-left: 60px;
    font-size: 16px;
    color: #222222;
    padding-bottom: 10px;
    font-weight: bolder;
  }

  &__form {
    text-align: left;
    padding-top: 20px;
  }

  &__verify {
    display: flex;
    align-items: center;
  }

  &__refresh {
    font-size: 24px;
    color: #07a8e1;
    width: 40px;
    cursor: pointer;
    text-align: center;
    // font-weight: bold;
  }

  &__pt10 {
    padding-top: 10px;
  }

  &__button {
    width: 100%;
  }

  &__text {
    padding-left: 60px;
    font-size: 13px;
  }

  &__suceess-text {
    text-align: center;
    padding-bottom: 40px;
    font-size: 13px;
  }

  &__app-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 60px;
    color: #999999;
    text-align: center;
    line-height: 60px;
    font-size: 13px;
  }
}
</style>
